import type { Auth } from '~~/shared-components/types/Auth'

export function useAuth() {
  return useState<Auth>('auth', () => ({
    user: null,
    token: null,
    permissions: null,
    foreignUser: false,
    expiresAt: null,
  }))
}
